<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="800">
    <v-form ref="form" class="white px-11 py-10">
      <v-row class="pb-9">
        <v-col cols="11">
          <p class="form__title mb-0 gray--text">
            ENDEREÇO
          </p>
        </v-col>
        <v-col cols="1" class="text-end pb-5">
          <BaseButton text icon @click="closeModal" class="justify-end">
            <v-icon size="17" color="gray" class="justify-end">
              fa-times
            </v-icon>
          </BaseButton>
        </v-col>
        <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5">
          <BaseFormInput
            id-element="cepInsurance"
            placeholder="Inserir"
            v-model="form.endereco.cep"
            :rules="validCEPAccordingOptionsQuotation"
            validate-on-blur
            v-facade="maskCEP"
            label-text="CEP"
          />
        </v-col>
        <v-col cols="12" sm="6" md="10">
          <BaseFormInput
            id-element="addressInsurance"
            placeholder="Inserir"
            v-model="form.endereco.logradouro"
            :rules="validAddressAccordingOptionsQuotation"
            label-text="Logradouro"
          />
        </v-col>
        <v-col cols="12" sm="6" md="2" class="pr-0 pr-sm-5">
          <BaseFormInput
            id-element="numberInsurance"
            placeholder="Inserir"
            v-model="form.endereco.numero"
            :rules="validNumberAccordingOptionsQuotation"
            label-text="Número"
          />
        </v-col>
        <v-col cols="12" sm="6" md="10">
          <BaseFormInput
            id-element="complementInsurance"
            placeholder="Inserir"
            v-model="form.endereco.complemento"
            label-text="Complemento"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5">
          <BaseFormSelect
            id-element="ufInsurance"
            placeholder="Selecione"
            v-model="form.endereco.uf"
            :items="brazilianStates"
            :rules="validAddressAccordingOptionsQuotation"
            label-text="UF"
            item-text="nome"
            item-value="sigla"
            :return-object="true"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
          <BaseFormInput
            id-element="cityInsurance"
            placeholder="Inserir"
            v-model="form.endereco.cidade"
            :rules="validAddressAccordingOptionsQuotation"
            label-text="Cidade"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-0 pr-sm-5 pr-md-0">
          <BaseFormInput
            id-element="neighborhoodInsurance"
            placeholder="Inserir"
            v-model="form.endereco.bairro"
            :rules="validAddressAccordingOptionsQuotation"
            label-text="Bairro"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3">
          <BaseButton
            @click="submit"
            class="secondary"
            width="100%"
            v-html="'ADICIONAR'"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput, isValidCep, maxLengthNumber } from "@/utils/rules.js";
import { brazilianStates } from "@/utils/utils.js";
import { maskCEP } from "@/utils/masks.js";
export default {
  data: () => ({
    requiredInput,
    brazilianStates,
    maskCEP,
    isValidCep,
    maxLengthNumber
  }),
  computed: {
    validAddressAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput] : [];
    },
    validCEPAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput, this.isValidCep] : [];
    },
    validNumberAccordingOptionsQuotation() {
      return this.validAdress ? [this.requiredInput, this.maxLengthNumber] : [];
    },
    validAdress() {
      return this.optionsPolicy?.segurado[this.form.segurado?.tipo_pessoa?.id]
        ?.endereco.obrigatorio;
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit");
    }
  },
  props: {
    form: {
      type: Object
    },
    optionsPolicy: {
      type: Object,
      default: () => null
    }
  }
};
</script>
